import { render, staticRenderFns } from "./CommonSetupForm.vue?vue&type=template&id=00a9ebf6&scoped=true&"
import script from "./CommonSetupForm.vue?vue&type=script&lang=js&"
export * from "./CommonSetupForm.vue?vue&type=script&lang=js&"
import style0 from "./CommonSetupForm.vue?vue&type=style&index=0&id=00a9ebf6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a9ebf6",
  null
  
)

export default component.exports